import {Undef} from 'app/interface';

export function updateHashBasedOnUrl(url: string, update = true): Undef<string> {
    // e.g. "/content/sites/sk/slsp/www-slsp-sk/sk/configuration/leads/cta-hypo-bez-prekazok/step-1.modal.html"
    // or "/content/sites/vendor/egit-int/regression_gem_erstegroupit_com/en/common-components/help-center-list/q-and-a/blue/kobaltblau2.question.html"
    // hash should be set to >> step-1 or kobaltblau2
    const pattern = /\/(([A-Z0-9\-_]+)\.(modal|question|compare))/i;
    const found = url.match(pattern);

    if (found && found[2]) {
        if (update) {
            window.location.hash = found[2];
        }

        return found[2];
    }
}
